// AUTO-GENERATED — do NOT edit by hand.
// Regenerated at every `yarn start` / `yarn build` from write-build-info.js.
// v200.41 · source: SHA-256(src/**/{.js,.jsx,.ts,.tsx,.css} + yarn.lock),
// deterministic path order. No env, no git, no asset-manifest.
export const APP_VERSION       = "v0bfb3b0260cd-2026-11-04T08:14";
export const APP_BUILD_DATE    = "2026-11-04";
export const APP_BUILD_TIME    = "2026-11-04T08:14:53.585Z";
export const APP_BUILD_MINUTE  = "2026-11-04T08:14";
export const APP_GIT_COMMIT    = "0bfb3b0260cd";
export const APP_COMMIT_SOURCE = "src+lock";
